import type {
  FormBlock,
  FormBlocks,
  WorkflowDefaultStepBlockType,
  WorkflowDefaultStepBlockTypeMap,
} from '../../types';

export const filterBlocksOfType = <T extends WorkflowDefaultStepBlockType>(
  blocks: FormBlocks,
  type: T,
): Array<WorkflowDefaultStepBlockTypeMap[T]> => {
  const reduceCallbackFn = (
    blocksAcc: Array<WorkflowDefaultStepBlockTypeMap[T]>,
    block: FormBlock,
  ): Array<WorkflowDefaultStepBlockTypeMap[T]> =>
    Array.isArray(block)
      ? block.reduce(reduceCallbackFn, blocksAcc)
      : ([...blocksAcc, ...(block.type === type ? [block] : [])] as Array<
          WorkflowDefaultStepBlockTypeMap[T]
        >);

  return blocks.reduce(reduceCallbackFn, []) as Array<
    WorkflowDefaultStepBlockTypeMap[T]
  >;
};
